import accounting from 'accounting';

export class MoneyHelper {
    static format(
        value,
        precision = accounting.settings.number.precision
    ) {
        const fixed = accounting.toFixed(value / Math.pow(10, precision), precision);

        return accounting.formatNumber(parseFloat(fixed));
    }

    static get getPrecision() {
        return accounting.settings.number.precision;
    }

    static get getDecimal() {
        return accounting.settings.number.decimal;
    }
}

